module.exports = __webpack_public_path__ + "static/terms-and-conds-6346894ff760904526073067d425c31d.jpg";